import { BrowserRouter } from 'react-router-dom'
import { AuthProvider, ThemeProvider, ToastProvider } from 'grabbitbot-legacy-ui'
import { apiClient } from './api'
import { AppRoutes } from './routes/AppRoutes'

export function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider client={apiClient}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}
